// extracted by mini-css-extract-plugin
module.exports = {"layout":"FaqPage_layout__sIi3S"};